<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="title-box">
                <div class="tit">资料下载</div>
                <div class="desc">在这里，让我们帮您找到您要的东西。</div>
            </div>
            <div class="search-box">
                <form @submit.prevent="doSearch">
                    <div class="left input">
                        <input type="text" placeholder="请输入关键词搜索" v-model="key">
                        <div class="clear" v-if="key.length > 0" @click="key = ''"></div>
                    </div>
                    <div class="right btn" @click="doSearch" :class="[key.length > 0 ? '' : 'hidden']"><span></span></div>
                </form>
            </div>
			<div class="tags-box" v-if="tags.length > 0">
				<div class="item" :class="[tags_choose === '' ? 'active' : '']" @click="tagsChoose('')">
					<div class="tit">全部</div>
				</div>
				<div class="item" :class="[item === tags_choose ? 'active' : '']" v-for="(item,index) in tags" :key="index" @click="tagsChoose(item)">
					<div class="tit">{{item}}</div>
				</div>
			</div>
            <div class="list" v-if="list.length > 0">
                <div class="clear box">
                    <div class=" item" v-for="item in list">
                        <div class="left title">
                            <div class="middle">{{item.title}}</div>
                        </div>
                        <div class="right btn-box" @click="showDownload(item)">
                            <div class="left type" :class="[item.type == 1 ? 'word' : item.type == 2 ? 'pdf' : 'ppt']"></div>
                            <div class="left btn">下载</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-loading" v-if="show_loading"><loading></loading></div>
            <div class="footer-2" v-if="list.length <= 0 && key">抱歉！没有找到相关的下载资料</div>
        </div>
        <down-load :file="file_info" v-if="file_info.file_id" @hideDownload="hideDownload"></down-load>
    </main>
</template>

<script>
    import Crumbs from "../../../components/m/Crumbs";
    import DownLoad from "../../../components/m/DownLoad";
    import Loading from "../../../components/m/Loading";
    export default {
        name: 'download',
        data() {
            return {
                adv:{},
                key:"",
                page:1,
                list:[],
                file_info:{},
                show_loading:true,
				tags:[],
				tags_choose:"",
            }
        },
        components:{
            Loading,
            Crumbs,DownLoad
        },
        computed:{
            crumbs() {
				return {title:"资料下载",min_title:"data download"}
            },
        },
        watch:{
            key(newVal,oldVal){
                if(!newVal && oldVal){
                    this.doSearch();
                }
            }
        },
        methods: {
			tagsChoose(item){
				this.tags_choose = item;
				this.getFile();
			},
            doSearch(){
                this.footer = "上拉加载更多";
                this.page = 1;
                this.list =[];
                this.getFile();
				this.getTags();
            },
            showDownload(item){
                this.file_info = item;
            },
            hideDownload(){
                this.file_info = false;
            },
			getTags(){
				this.http.request({
					api:"file/tags",
					data:{
						key:this.key,
					},
					success:(res)=>{
						this.tags = res.tags;
					}
				})
			},
            getFile(){
                this.show_loading = true;
                this.http.request({
                    api:"file/getFile",
                    data:{
                        limit:999,
                        key:this.key,
						tag:this.tags_choose,
                        page:this.page,
                    },
                    success:(res)=>{
                        this.list = res.list;
                        this.show_loading = false;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            },
            checkLogin(){
                if(!this.util.getAccessToken()){
                    this.util.showAuth({
                        show:true,
                        close_btn:true,
                    })
                }
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.getFile();
			this.getTags();
            this.checkLogin();
        },
        destroyed() {
            this.util.showAuth({
                show:false,
            })
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{background:#f6f6f6 url("~@/assets/image/2021/17_m.png") no-repeat bottom center;background-size:100% auto;padding-top:.25rem;
        .title-box{padding:.25rem;background: #fff;box-shadow:0 0 .1rem .02rem rgba(0,0,0,.1);width: 6.5rem;margin: 0 auto;
            .tit{font-size:.26rem;line-height:.32rem;border-left: .04rem solid #0176ce;padding-left:.1rem;font-weight: bold;}
            .desc{font-size: .22rem;margin-top: .1rem;line-height: .32rem;color:#565656;padding-left: .14rem;white-space: pre-line}
        }
        .search-box{height:.6rem;overflow: hidden;margin: .3rem auto 0;width: 7rem;
            .input{width:5.6rem;padding: 0 .2rem;background: #fff;position: relative;
                input{width:100%; height:.4rem;padding: .1rem 0; line-height: .4rem;background: none;border: none;font-size:.28rem;color:#000;}
                .clear{display: block;position:absolute;top:0;right:0; width:.6rem;height:.6rem;line-height: .6rem;background: url("~@/assets/image/m10.png") no-repeat center center;background-size:.3rem; cursor: pointer;}
            }
            .btn{width: 1rem;height:.6rem;text-align: center;line-height:.6rem;color:#fff;background: #3176c8;font-size:.28rem;cursor: pointer;
                span{display: inline-block;width: .4rem;height:.6rem;background: url("~@/assets/image/76.png") no-repeat center center;background-size: .3rem}
            }
            .btn.hidden{background: #999;}
        }
		.tags-box{margin: .3rem auto 0;width: 7rem;display: flex;align-items: center;flex-wrap: wrap;
			.item{ padding: .15rem .3rem;display: flex;align-items: center;justify-content: center;cursor: pointer;
				.tit{position: relative;padding-bottom:.05rem;}
				.tit::after{content: "";display: block;position: absolute;bottom:0;left:0;width: 0;height:.03rem; background: #3176c8;border-radius: .02rem;}
			}
			.item.active{
				.tit{color:#3176c8;}
				.tit::after{width: 100%;transition: all .3s ease;}
			}
		}
        .list{overflow: hidden;margin: .25rem auto 0;
            .box{padding-bottom: 1rem;
                .item{background: #fff;margin:0 auto .25rem;padding: .3rem;width: 6.4rem;overflow: hidden;
                    .title{height:1rem;width: 4.3rem;border-right: .02rem solid #f3f3f3;padding-right: .3rem;
                        .middle{height:1rem;font-size:.26rem;line-height: .4rem;color:#565656;}
                    }
                    .btn-box{padding-top:.3rem;cursor: pointer;
                        .type{width: .6rem;height:.6rem;background-repeat: no-repeat;background-position: center center;background-size: contain;}
                        .type.word{background-image: url("~@/assets/image/25_1.png");}
                        .type.pdf{background-image: url("~@/assets/image/23.png");}
                        .type.ppt{background-image: url("~@/assets/image/24.png");}
                        .btn{font-size:.24rem;color:#3176c8;padding-left:.24rem;background: url("~@/assets/image/25.png") no-repeat left center;background-size:.18rem;margin-left:.15rem;height:.6rem;line-height: .6rem;}
                    }
                }
            }
        }
        .loading{height:5rem;text-align: center;line-height: 5rem;font-size: .26rem;color:#999;}
    }
    .footer-2{height:6rem;text-align: center;line-height: 4rem;font-size: .26rem;color:#999;}
</style>

